import React from 'react'
import { Card, Col, Row, Statistic } from 'antd'
import {
  SwapOutlined,
  ArrowDownOutlined,
  ArrowUpOutlined,
  DollarOutlined,
  AppstoreAddOutlined
} from '@ant-design/icons'
import { TMovementSummary } from '../../../../utils/reportUtils'
import { textNumberFormater } from '../../../../utils'

interface MovementSummaryCardsProps {
  summary: TMovementSummary
  loading?: boolean
}

export const MovementSummaryCards: React.FC<MovementSummaryCardsProps> = ({ summary, loading = false }) => {
  return (
    <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
      <Col xs={24} sm={12} md={8} lg={4.8}>
        <Card loading={loading} size="small" style={{ borderRadius: 8, borderColor: '#e8e8e8' }}>
          <Statistic
            title="Total Movimientos"
            value={summary.totalMovements}
            prefix={<SwapOutlined style={{ color: '#1890ff' }} />}
            valueStyle={{ color: '#1890ff', fontWeight: 600, fontSize: '1.4rem' }}
          />
        </Card>
      </Col>

      <Col xs={24} sm={12} md={8} lg={4.8}>
        <Card loading={loading} size="small" style={{ borderRadius: 8, borderColor: '#e8e8e8' }}>
          <Statistic
            title="Total Entradas"
            value={summary.totalEntriesAmount}
            formatter={(val) => `$ ${textNumberFormater(Number(val))}`}
            prefix={<ArrowDownOutlined style={{ color: '#52c41a' }} />}
            valueStyle={{ color: '#52c41a', fontWeight: 600, fontSize: '1.3rem' }}
          />
        </Card>
      </Col>

      <Col xs={24} sm={12} md={8} lg={4.8}>
        <Card loading={loading} size="small" style={{ borderRadius: 8, borderColor: '#e8e8e8' }}>
          <Statistic
            title="Total Salidas"
            value={summary.totalExitsAmount}
            formatter={(val) => `$ ${textNumberFormater(Number(val))}`}
            prefix={<ArrowUpOutlined style={{ color: '#ff4d4f' }} />}
            valueStyle={{ color: '#ff4d4f', fontWeight: 600, fontSize: '1.3rem' }}
          />
        </Card>
      </Col>

      <Col xs={24} sm={12} md={8} lg={4.8}>
        <Card loading={loading} size="small" style={{ borderRadius: 8, borderColor: '#e8e8e8' }}>
          <Statistic
            title="Balance Neto"
            value={summary.netBalanceAmount}
            formatter={(val) => `$ ${textNumberFormater(Number(val))}`}
            prefix={<DollarOutlined style={{ color: summary.netBalanceAmount >= 0 ? '#13c2c2' : '#fa8c16' }} />}
            valueStyle={{
              color: summary.netBalanceAmount >= 0 ? '#13c2c2' : '#fa8c16',
              fontWeight: 600,
              fontSize: '1.3rem'
            }}
          />
        </Card>
      </Col>

      <Col xs={24} sm={12} md={8} lg={4.8}>
        <Card loading={loading} size="small" style={{ borderRadius: 8, borderColor: '#e8e8e8' }}>
          <Statistic
            title="Items Movidos"
            value={summary.totalItemsMoved}
            prefix={<AppstoreAddOutlined style={{ color: '#722ed1' }} />}
            valueStyle={{ color: '#722ed1', fontWeight: 600, fontSize: '1.4rem' }}
          />
        </Card>
      </Col>
    </Row>
  )
}

export default MovementSummaryCards
